<template>
  <div>
    <h3>New Module</h3>

    <vx-card no-shadow class="mt-8">
      <h2 class="mb-6">Information</h2>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Title</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <i8n-input label="" placeholder="Title..." :content.sync="title" class="w-full" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Description</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <i8n-textarea placeholder="Description..." :content.sync="description" class="w-full" />
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Required Performance Score</span>
        </div>
        <div class="vx-col">
          <vs-input v-validate="'numeric'" name="requiredPerformanceScore" v-model="requiredPerformanceScore" />
          <div class="text-danger text-sm" v-show="errors.has('requiredPerformanceScore')">{{ errors.first('requiredPerformanceScore') }}</div>
        </div>
      </div>
    </vx-card>

    <!-- Add Module Button -->
    <div class="flex flex-wrap items-center justify-end mt-12">
      <vs-button
        @click="addModule"
        id="save-button"
        class="ml-auto mr-auto mt-2"
        size="large"
      >Add Module</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      surveyId: '',

      // Module information
      title: '',
      description: '',
      requiredPerformanceScore: 0
    };
  },
  methods: {
    addModule: function() {
      this.$vs.loading()

      const payload = {
        title: this.title,
        description: this.description,
        requiredPerformanceScore: parseInt(this.requiredPerformanceScore),
      };

      const url = process.env.VUE_APP_API +'/Surveys/4/' + this.surveyId + '/modules';

      this.$http.post(url, payload)
        .then(resp => {
          if (resp.data.success === true) {
            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Module added'
            });

            this.$router.push({ name: 'admin-survey-online-training-module', params: { surveyId: this.surveyId, moduleId: resp.data.moduleId } }).catch(() => {})
          } else {
            console.log(resp.data.error);

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not add module: ' + resp.data.error
            });
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    }
  },
  created() {
    this.surveyId = this.$route.params.surveyId;
  }
};
</script>

<style lang="scss" scoped>
.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>